import { convertDateToUnixTime } from "../../converters/convertDateToUnixTime";
import { validateInput } from "../tools/validateInput";

export const plotVerticalLineAtCreationTime = (createdAt, createWidget) => {
  validateInput(createdAt, "createdAt", "plotVerticalLineAtCreationTime");

  const getDateToUnixTime = convertDateToUnixTime(1, createdAt);
  createWidget.verticalLine(getDateToUnixTime, "analisisCreatedAt", 2);
};
